import { render, staticRenderFns } from "./speedMeasurementRecord.vue?vue&type=template&id=5caf3af3&scoped=true&"
import script from "./speedMeasurementRecord.vue?vue&type=script&lang=js&"
export * from "./speedMeasurementRecord.vue?vue&type=script&lang=js&"
import style0 from "./speedMeasurementRecord.vue?vue&type=style&index=0&id=5caf3af3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caf3af3",
  null
  
)

export default component.exports